const isCorrectPath = () => window.location.pathname === "/";

const shownPreviously = () =>
  sessionStorage
    ? sessionStorage.getItem("splash-animation-shown") === "yes"
    : false;

const isSmallDevice = () => window.innerHeight < 500 || window.innerWidth < 500;

export const enableSplashScreen = () => {
  if (isCorrectPath() && !shownPreviously() && !isSmallDevice()) {
    jQuery("#splash-screen").removeClass("splash-hidden");
    jQuery("body").addClass("splash-screen-is-overflow-hidden");

    if (sessionStorage) sessionStorage.setItem("splash-animation-shown", "yes");

    const setCanvasSize = () => {
      const height = window.outerHeight;
      const width = window.outerWidth;
      jQuery("#splash-screen").css("height", `${height}px`);
      jQuery("#splash-screen").css("width", `${width}px`);
    };

    setCanvasSize();

    if (jQuery("#splash-screen video").length)
      jQuery("#splash-screen video")[0].play();

    jQuery(window).bind("resize.splash", setCanvasSize);
    setTimeout(function () {
      jQuery(window).unbind("resize.splash");
      jQuery("body").removeClass("splash-screen-is-overflow-hidden");
      jQuery("#splash-screen").addClass("enable-animation");
      jQuery("#splash-screen").css("height", `0px`);

      setTimeout(function () {
        jQuery("#splash-screen").remove();
      }, 1000);
    }, 2850);
  }
};
